var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleSheets = function SvgGoogleSheets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 49 67"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "google_sheets_svg__a",
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_sheets_svg__c",
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_sheets_svg__e",
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_sheets_svg__h",
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_sheets_svg__j",
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_sheets_svg__l",
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_sheets_svg__n",
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "google_sheets_svg__p",
    cx: "3.168%",
    cy: "2.717%",
    r: "161.249%",
    fx: "3.168%",
    fy: "2.717%",
    gradientTransform: "matrix(1 0 0 .72727 0 .007)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_sheets_svg__f",
    x1: "50.005%",
    x2: "50.005%",
    y1: "8.586%",
    y2: "100.014%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#263238",
    stopOpacity: 0.02
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google_sheets_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_sheets_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F9D58",
    fillRule: "nonzero",
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75L36.98 10.354z",
    mask: "url(#google_sheets_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google_sheets_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_sheets_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    fillRule: "nonzero",
    d: "M11.833 31.802V53.25H35.5V31.802zm10.355 18.49h-7.396v-3.698h7.396zm0-5.917h-7.396v-3.698h7.396zm0-5.917h-7.396V34.76h7.396zm10.354 11.834h-7.396v-3.698h7.396zm0-5.917h-7.396v-3.698h7.396zm0-5.917h-7.396V34.76h7.396z",
    mask: "url(#google_sheets_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google_sheets_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_sheets_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_sheets_svg__f)",
    fillRule: "nonzero",
    d: "M30.881 16.452 47.333 32.9V17.75z",
    mask: "url(#google_sheets_svg__g)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google_sheets_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_sheets_svg__h"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#google_sheets_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87CEAC",
    fillRule: "nonzero",
    d: "M29.583 0v13.313a4.436 4.436 0 0 0 4.438 4.437h13.312z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google_sheets_svg__k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_sheets_svg__j"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    fillRule: "nonzero",
    d: "M4.438 0A4.45 4.45 0 0 0 0 4.438v.37A4.45 4.45 0 0 1 4.438.37h25.145V0z",
    mask: "url(#google_sheets_svg__k)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google_sheets_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_sheets_svg__l"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.2,
    fillRule: "nonzero",
    d: "M42.896 64.714H4.438A4.45 4.45 0 0 1 0 60.276v.37a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437v-.37a4.45 4.45 0 0 1-4.437 4.438",
    mask: "url(#google_sheets_svg__m)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.833 .958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google_sheets_svg__o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_sheets_svg__n"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    fillRule: "nonzero",
    d: "M34.02 17.75a4.436 4.436 0 0 1-4.437-4.437v.37a4.436 4.436 0 0 0 4.438 4.437h13.312v-.37z",
    mask: "url(#google_sheets_svg__o)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_sheets_svg__p)",
    fillRule: "nonzero",
    d: "M29.583 0H4.438A4.45 4.45 0 0 0 0 4.438v56.208a4.45 4.45 0 0 0 4.438 4.437h38.458a4.45 4.45 0 0 0 4.437-4.437V17.75z",
    transform: "translate(.833 .958)"
  }))));
};
export default SvgGoogleSheets;